export const graphOptions = [
  {
    label: "Semaine",
    value: "week",
  },
  {
    label: "Mois",
    value: "month",
  },
  {
    label: "Jour",
    value: "year",
  },
];

export const pieChartOptions = [
  {
    label: "Industrie",
    value: "industry",
  },
  {
    label: "Catégories",
    value: "categories",
  },
  {
    label: "Rubriques",
    value: "sections",
  },
];

export const articlesPieChartColors = [
  "#FFC107",
  "#002459",
  "#B1E3FF",
  "#FFE082",
  "#004A9C",
  "#8ECDF7",
  "#FFB300",
  "#5B7FBF",
  "#CC9E00",
  "#001737",
  "#5D9EC2",
  "#E6B800",
  "#405973",
  "#4AA4E7",
];

export const companiesPieChartColors = [
  "#FF8000",
  "#219B9D",
  "#4C1F7A",
  "#E67300",
  "#E67300",
  "#8762AD",
  "#FF5C00",
  "#145F60",
  "#2C0F4A",
  "#CC6600",
  "#1A7D7E",
  "#A98AC6",
  "#994C00",
  "#0D4042",
  "#8F819A",
];
